import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Edit, usePermissions, regex, useDataProvider, useTranslate } from 'react-admin';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import { UserForm } from '@/components/users/forms/UserForm.jsx';
import { formTransform } from '@/components/users/forms/formTransform.js';
import { userDrawerStyles } from '@/themes/commonStyles/user.js';

export const StyledUserDrawer = styled(Box)(userDrawerStyles);

export const UserEdit = ({ handleClose, elementId }) => {
    const { permissions } = usePermissions();
    const dataProvider = useDataProvider();
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const translate = useTranslate();

    useEffect(() => {
        if (elementId) {
            setIsLoading(true);
            dataProvider
                .getOne('user', { id: elementId })
                .then(() => {
                    setError(null);
                })
                .catch(err => {
                    console.error('Error fetching user:', err);
                    setError(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [dataProvider, elementId]);

    if (isLoading) return null;
    if (error) return <Typography>{translate('common.errors.loadingData')}</Typography>;

    const isAdmin = permissions.isAdmin;
    const validatePhone = regex(/^(\+48)[1-9]\d{8}$/, translate('resources.user.validation.invalidPhone'));
    const invalidEmail = translate('common.validation.invalidEmail');

    return (
        <StyledUserDrawer>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.user.labels.editUser')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <Edit mutationMode='pessimistic' transform={formTransform} id={elementId} actions={false} redirect={false}>
                <UserForm isAdmin={isAdmin} validatePhone={validatePhone} invalidEmail={invalidEmail} handleClose={handleClose} isEdit={true} />
            </Edit>
        </StyledUserDrawer>
    );
};

UserEdit.propTypes = {
    handleClose: PropTypes.func,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
